<template>
  <div :class="`eyedropper ${selected ? 'selected' : ''} `">
    <i class="mdi mdi-eyedropper"
       @click="selectColor"></i>
  </div>
</template>

<script>
    import selectable from '@mixins/selectable'
    import vModel from '@mixins/v-model'
    import EventBus from '@packages/event-bus'
    import rgbaToCss from '@packages/mixins/rgba-to-css';


    export default {
        components: {  
        },

        data() {
            return {
              selected: false
            }
        },

        props: {
          interaction: {
            type: Object,
            required: true
          },
          type: {
            type: String,
            required: true
          },
          entity: {
            type: String,
            required: false,
            default: 'interactions'
          }
        },

        watch: {
          colorPickerColor: {
            deep: true,
            handler: function() {
              if(this.selected) {
                const isColorPickerColorObj = typeof this.colorPickerColor === 'object'
                this.$emit('input', !this.isInteractionEntity && isColorPickerColorObj ? this.rgbaToCss(this.colorPickerColor) : this.colorPickerColor);
                this.unselectPickers();
              }
            }
          }
        },

        computed: {
          colorPickerColor() {
            return this.$store.state[this.entity].colorPicker.color
          },
          colorPicker() {
            return this.$store.state[this.entity].colorPicker
          },
          isInteractionEntity() {
            return this.entity === 'interactions';
          },
          setColorPickerStateMutation() {
            return this.isInteractionEntity ? 'SET_COLOR_PICKER_STATE_INTERACTION' : 'SET_COLOR_PICKER_STATE_CAPTIVE_STYLE'
          }
        },

        methods: {
          selectColor() {
            this.selected = !this.selected;

            if(this.selected) {
              const colorPickerState = {
                active: this.selected,
                
                type: this.type,
              }
              if(this.isInteractionEntity) {
                colorPickerState.interactionId = this.interaction.id
              } else {
                colorPickerState.captiveStyleId = this.interaction.id
              }
              this.$store.commit(this.setColorPickerStateMutation, colorPickerState)
            } else {
              const colorPickerState = {
                active: this.selected,
                interactionId: undefined,
                type: undefined,
              }
              this.$store.commit(this.setColorPickerStateMutation, colorPickerState)
            }

            EventBus.$emit('UNSELECT_OTHER_COLOR_PICKERS')
          },
          unselectOtherPickers() {
            const id = this.isInteractionEntity ? 'interactionId' : 'captiveStyleId'
            if(this.colorPicker.active && (this.colorPicker[id] !== this.interaction.id || this.colorPicker.type !== this.type)) {
              this.selected = false;
            } 
          },
          unselectPickers() {
            const colorPickerState = {
              active: false,
              interactionId: undefined,
              type: undefined,
            }
            this.$store.commit(this.setColorPickerStateMutation, colorPickerState)
            this.selected = false;
          },
          clickHandler() {
            EventBus.$emit('UNSELECT_OTHER_COLOR_PICKERS')
            this.$store.commit(this.setColorPickerStateMutation, {
              active: false
            })
          }
        },

        mounted() {
          EventBus.$on('CLICK', this.clickHandler)
          EventBus.$on('UNSELECT_OTHER_COLOR_PICKERS', this.unselectOtherPickers)
        },

        beforeDestroy() {
          EventBus.$off('CLICK', this.clickHandler)
          EventBus.$off('UNSELECT_OTHER_COLOR_PICKERS', this.unselectOtherPickers)
        },

        mixins: [selectable, vModel, rgbaToCss]
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.eyedropper {
  cursor: pointer;
  color: $grey-4;
  margin: 0 0 0 auto;

  &.selected {
    // cursor: url(../../../../eyedropper.png) 4 12, auto;
    color: $selected;
  }

  #color-preview {
    position: fixed;
    z-index: 1000;
  }
}
</style>
